import script from "./editTerminal.vue?vue&type=script&setup=true&lang=js"
export * from "./editTerminal.vue?vue&type=script&setup=true&lang=js"

import "./editTerminal.vue?vue&type=style&index=0&id=18c219ed&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-18c219ed"]])

export default __exports__